export const CONFIG_ECG = {
  samplingFrequency: 200,
  gain: 655.35875,
};
